import * as THREE from 'three'
import { Side } from 'src/constants/sides'
import { Octant, ReferencePoint } from 'src/constants/referencePoints'

type Vector3Array = [number, number, number]

export const getOctants = (boundings: THREE.Box3): { [key in Octant]: Vector3Array } => {
  const { min, max } = boundings
  const center = new THREE.Vector3()
  boundings.getCenter(center)
  return {
    [-13]: min.toArray() as Vector3Array,
    [-12]: [center.x, min.y, min.z],
    [-11]: [max.x, min.y, min.z],
    [-10]: [min.x, center.y, min.z],
    [-9]: [center.x, center.y, min.z],
    [-8]: [max.x, center.y, min.z],
    [-7]: [min.x, max.y, min.z],
    [-6]: [center.x, max.y, min.z],
    [-5]: [max.x, max.y, min.z],
    [-4]: [min.x, min.y, center.z],
    [-3]: [center.x, min.y, center.z],
    [-2]: [max.x, min.y, center.z],
    [-1]: [min.x, center.y, center.z],
    0: center.toArray() as Vector3Array,
    1: [max.x, center.y, center.z],
    2: [min.x, max.y, center.z],
    3: [center.x, max.y, center.z],
    4: [max.x, max.y, center.z],
    5: [min.x, min.y, max.z],
    6: [center.x, min.y, max.z],
    7: [max.x, min.y, max.z],
    8: [min.x, center.y, max.z],
    9: [center.x, center.y, max.z],
    10: [max.x, center.y, max.z],
    11: [min.x, max.y, max.z],
    12: [center.x, max.y, max.z],
    13: max.toArray() as Vector3Array
  }
}

export const referencePointMap: { [key in Side]: { [key in ReferencePoint]: Octant } } = {
  front: {
    topLeft: 11,
    topCenter: 12,
    topRight: 13,
    centerLeft: 8,
    centerCenter: 9,
    centerRight: 10,
    bottomLeft: 5,
    bottomCenter: 6,
    bottomRight: 7
  },
  top: {
    topLeft: 11,
    topCenter: 2,
    topRight: -7,
    centerLeft: 12,
    centerCenter: 3,
    centerRight: -6,
    bottomLeft: 13,
    bottomCenter: 4,
    bottomRight: -5
  },
  right: {
    topLeft: 13,
    topCenter: 4,
    topRight: -5,
    centerLeft: 10,
    centerCenter: 1,
    centerRight: -8,
    bottomLeft: 7,
    bottomCenter: -2,
    bottomRight: -11
  },
  bottom: {
    topLeft: 7,
    topCenter: -2,
    topRight: -11,
    centerLeft: 6,
    centerCenter: -3,
    centerRight: -12,
    bottomLeft: 5,
    bottomCenter: -4,
    bottomRight: -13
  },
  left: {
    topLeft: -7,
    topCenter: 2,
    topRight: 11,
    centerLeft: -10,
    centerCenter: -1,
    centerRight: 8,
    bottomLeft: -13,
    bottomCenter: -4,
    bottomRight: 5
  },
  back: {
    topLeft: -5,
    topCenter: -6,
    topRight: -7,
    centerLeft: -8,
    centerCenter: -9,
    centerRight: -10,
    bottomLeft: -11,
    bottomCenter: -12,
    bottomRight: -13
  }
}
